<template>
  <section class="architecture">
    <div class="container">
      <a-typography-title :level="1">
        方案架构
      </a-typography-title>
      <a-row>
        <a-col :xs="24" :lg="12">
          <div class="box_content">
            <a-typography-title :level="5">
              基于通用Serverless平台<br>的多活部署方案
            </a-typography-title>
            <a-typography-paragraph>
              <span>星汉未来全场景通用Serverless平台实现了部署、发布、性能、稳定性治理的全自动化，</span>
              <span>基于此Serverless平台提供的多活解决方案，能将整套业务应用一键复制到多套环境中。</span>
              <span>只需要管理其中一套环境，相关数据及设置会自动同步至其他环境。</span>
              <span>提供应用治理、中间件统一治理、数据备份等能力，大大降低业务多活部署的难度和运维复杂度。</span>
            </a-typography-paragraph>
          </div>
        </a-col>
        <a-col :xs="24" :lg="12">
          <div class="box_image">
            <img alt=""
                 :src="file.ImageBottom" />
            <img alt=""
                 :src="file.Image" />
            <img alt=""
                 :src="file.ImageBorder" />
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import ImageBottom from '@resource/image/page/planActive/architecture_bottom.png';
import Image from '@resource/image/page/planActive/architecture_image.png';
import ImageBorder from '@resource/image/page/planActive/architecture_border.png';

export default {
  name: 'plan_architecture',
  data(): DataInterface {
    return {
      file: {
        ImageBottom,
        Image,
        ImageBorder
      },
      expand: {
        list: [
          {
            title: '覆盖所有服务，方能真正实现多活',
            text: '企业应用成百上千且不断演进，往往难以精准梳理应用间依赖关系。如果仅针对核心应用实施多活而不覆盖相应应用依赖，多活效果往往不如预期。'
          },
          {
            title: '需要覆盖所有技术栈，技术难度大',
            text: '为确保业务稳定运行，所有中间件都需要支持双活，除主流技术外，自研组件以及后续要迭代的新技术，都需要做多机房数据同步，技术难度较高。'
          },
          {
            title: '应用配套系统需要高度自动化',
            text: '多活业务的配套服务和流程，如发布、测试、监控、降级系统，都需要进行相应多活改造。为降低配套系统的运维工作量，系统高度自动化成为必需。'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planActive/';

.architecture {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.box_content {
  position: relative;
  max-width: 450px;
  margin: 0 auto;
  
  h5.ant-typography {
    position: relative;
    padding-bottom: 25px;
    margin: 0;
    .font(left, @title_sub+@line, @color_12, @title_sub, true);
    
    &::before {
      content: '';
      display: block;
      .position(absolute, auto, auto, 0, 0);
      width: 150px;
      height: 3px;
      background: @color_6;
      border-radius: 3px;
    }
  }
  
  div.ant-typography {
    margin: @margin 0 0;
    .font(left, @text+@line, @color_13, @text);
  }
}

.box_image {
  position: relative;
  height: 320px;
  
  img {
    display: block;
    .center();
    
    &:nth-child(1) {
      width: 549px;
      .position(absolute, calc(~'50% + 160px'), auto, auto, 50%);
      .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.02'), calc(~'-50% + var(--mouse-y,0px) * -0.02')));
    }
    
    &:nth-child(2) {
      width: 500px;
      .position(absolute, calc(~'50% - 10px'), auto, auto, 50%);
      .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.01'), calc(~'-50% + var(--mouse-y,0px) * -0.01')));
    }
    
    &:nth-child(3) {
      width: 616px;
      .position(absolute, calc(~'50% + 80px'), auto, auto, 50%);
      .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.02'), calc(~'-50% + var(--mouse-y,0px) * -0.02')));
    }
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_image {
    .transform(scale(0.8));
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .architecture {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .box_content {
    h5.ant-typography {
      padding: 0;
      .font(center, @text_big_mo+@line, @color_12, @text_big_mo, true);
      
      &::before {
        display: none;
      }
    }
    
    div.ant-typography {
      margin: @margin_mo 0 0;
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
  
  .box_image {
    height: 250px;
    .transform(scale(0.6));
  }
}
</style>